import { useContext } from 'react';
import { GlobalContext } from 'contexts/GlobalContext';

// ==============================|| CONFIG - HOOKS  ||============================== //

const useGlobal = () => useContext(GlobalContext);

export default useGlobal;
